import { AppServiceImpl } from "./appService"
import { ConnectBasicCtrl } from "./connect/basic"
import { ConnectOAuthCtrl } from "./connect/oauth"
import { ConnectPopupCtrl } from "./connect/popup"
import { ManageCtrl } from "./manage/manage"

/// <reference path="types.ts" />
/// <reference path="appService.ts" />
/// <reference path="manage/manage.ts"/>
/// <reference path="connect/oauth.ts" />

/** @internal */
export function setupApps(module: ng.IModule) {

    return module
        .service("OmniaApps", AppServiceImpl)
        .directive("omniaAppsManage", ManageCtrl.create)
        .directive("omniaAppsConnectOauth", ConnectOAuthCtrl.create)
        .directive("omniaAppsConnectBasic", ConnectBasicCtrl.create)
        .directive("omniaAppsConnectPopup", ConnectPopupCtrl.create)

}
